define('services/common/ajax/hispaceStore',['app'], function (app) {
    app.factory('HispaceStore', ['$q', 'auiAjaxWithError',function ($q, auiAjaxWithError) {
        return {
            getAppParameter: auiAjaxWithError.curryWithoutError('HispaceStore','HispaceStore.store.getAppParameter')
        }
    }])
});
